<partial-loading-indicator class="dex-dev-rates-w_loading-indicator -table-only" #loadingIndicator>
    <div class="dex-dev-rates-w_complex-table" [table]="table">
        <div class="dex-dev-rates-w_table-header-wrapper">
            <table class="dex-dev-rates-w_table">
                <thead>
                <tr tableHeaderRow>
                    <th textHiding *tableColumn="table.columnsDict.PAIR; let column" class="dex-dev-rates-w_table_header -pair"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.RATE; let column" class="dex-dev-rates-w_table_header -rate"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.DATE; let column" class="dex-dev-rates-w_table_header -date"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                </tr>
                </thead>
            </table>
        </div>
        <div class="dex-dev-rates-w_table-body-wrapper" customScrollbar [elementRuler]="resize$">
            <table class="dex-dev-rates-w_table">
                <tbody>
                <tr *tableBodyRow="let row of table.rows"
                    class="dex-dev-rates-w_table_row">

                    <td *tableColumn class="dex-dev-rates-w_table_cell -pair">
                        <span>{{row.pair}}</span>
                    </td>
                    <td textHiding *tableColumn class="dex-dev-rates-w_table_cell -rate"
                        tooltip #rateTooltip="tooltip">
                        <span [displayDecimal]="row.price.v | bigintDeliverableDisplayDecimal:row.price.d" [tooltipDirective]="rateTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-dev-rates-w_table_cell -date" tooltip>
                        <span>{{row.updatedAt}}</span>
                    </td>
                </tr>

                <!-- EMPTY ROWS -->
                <tr *tableBodyEmptyRow class="dex-dev-rates-w_table_row -empty">
                    <td *tableColumn class="dex-dev-rates-w_table_cell"></td>
                    <td *tableColumn class="dex-dev-rates-w_table_cell"></td>
                    <td *tableColumn class="dex-dev-rates-w_table_cell"></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</partial-loading-indicator>
